export default "__VITE_ASSET__eeae8342__"